// extracted by mini-css-extract-plugin
export default {"chapterTitleLeft":"chapterTitle_chapterTitleLeft__XAb6S","chapterTitleRight":"chapterTitle_chapterTitleRight__1mCFa"};